import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFormattingRules = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#FormattingRules_svg__a)">
      <path d="m16.29 3.09-.37-.37c-.64-.64-1.07-1.07-1.73-1.07s-1.09.43-1.73 1.07L5.69 9.49c-.18.18-.32.32-.43.51s-.15.36-.22.63l-.64 2.55c-.1.39-.22.87.17 1.25.2.2.43.27.66.27.21 0 .41-.05.6-.1l2.55-.64c.27-.07.44-.11.63-.22s.32-.23.51-.43l6.77-6.77c.64-.64 1.07-1.07 1.07-1.73s-.43-1.09-1.07-1.73zM2.4 17.63c0-.41.34-.75.75-.75h13.56c.41 0 .75.34.75.75s-.34.75-.75.75H3.15c-.41 0-.75-.34-.75-.75" />
    </g>
    <defs>
      <clipPath id="FormattingRules_svg__a">
        <path d="M2.4 1.65h15.06v16.73H2.4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFormattingRules;
